(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('DivisaController', DivisaController);

    /* @ngInject */
    function DivisaController(divisas) {
        var vm = this;
        vm.divisas = divisas;

        vm.countElements = function () {
            var keys = Object.keys(divisas);
            var counter = 0;

            for(var i=0; i < keys.length; i++) {
                var key = keys[i];
                counter += divisas[key].length;
            }

            return counter;
        };
    }
})(angular);
